import {ResourceConfig} from "@hidat/huijs-resource";
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nNumber,
  nString,
  uBoolean,
  uNumber,
  uString,
  Uuid
} from "@hidat/huijs-common";
import {RblFieldConfigs, RblResourceInterface, RblTenantResourceInterface} from "../rbl-resource.interface";
import {ZonedDateTime} from "@js-joda/core";

export const TitleConfig = new ResourceConfig('Title', 'titles', false, true)
  .addFields([
    RblFieldConfigs.id,
    RblFieldConfigs.uid,

    new FieldConfig('name').setRequired(true),
    new FieldConfig('nameExtended'),
    new FieldConfig('artistName'),
    new FieldConfig('collectionName'),
    new FieldConfig('rightsOwnerName'),
    new FieldConfig('duration', FieldDataTypes.NUMBER),

    new FieldConfig('contentKlass').setRequired(true),
    new FieldConfig('contentExtended', FieldDataTypes.HASH),

    new FieldConfig('isCollection', FieldDataTypes.BOOLEAN),
    RblFieldConfigs.title.setEditable(true),
    new FieldConfig('contentDate1', FieldDataTypes.DATETIME),
    new FieldConfig('contentDate2', FieldDataTypes.DATETIME),

    /* subclasses
    new FieldConfig('albumArtistName'),
    new FieldConfig('releaseYear'),
    new FieldConfig('trackNum', FieldDataTypes.INTEGER),
    new FieldConfig('totalTracks', FieldDataTypes.INTEGER),
     */

  ])
  .setSorts({
    name: "name",
    artistname: {
      dbName: 'artistName',
      secondarySort: {
        dbName: 'name'
      }
    }
  })
  .setDefaultSort('name')

export interface TitleInterface extends RblResourceInterface<number> {
  uid: Uuid | undefined;
  name: uString;
  nameExtended: nString;
  artistName: nString;
  collectionName: nString;
  rightsOwnerName: nString;
  duration: uNumber;

  contentKlass: nString;
  contentExtended: AnyHash | undefined;

  isCollection: uBoolean;
  titleId: nNumber;
  contentDate1: ZonedDateTime | undefined | null;
  contentDate2: ZonedDateTime | undefined | null;
}
